import styled from 'styled-components';

import { Checkbox as CheckboxComponent } from '@xingternal/checkbox';
import { Flag as FlagComponent } from '@xingternal/flag';
import { Label as LabelComponent } from '@xingternal/label';
import { spaceM, spaceS, spaceXXL, xdlColorHover } from '@xingternal/tokens';

export const FilterContainer = styled.div`
  margin-top: ${spaceM};
  margin-right: ${spaceXXL};

  &:last-child {
    margin-right: 0;
  }
`;

export const Label = styled(LabelComponent)`
  padding: ${spaceM} ${spaceS};
  cursor: pointer;

  &:hover,
  &:focus {
    border-radius: ${spaceS};
    background: ${xdlColorHover};
  }
`;

export const Checkbox = styled(CheckboxComponent)`
  margin-right: ${spaceM};
`;

export const Flag = styled(FlagComponent)`
  margin-left: ${spaceS};
`;
